import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Container, Form, FormGroup, Row } from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb"
import { MetaTags } from "react-meta-tags";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import SfLoadingSkeleton from "components/Common/Loadings/SfLoadingSkeleton";
import BootstrapTable from 'react-bootstrap-table-next';
import { AppConfiguration } from 'config';
import { useDispatch, useSelector } from "react-redux";
import { dateCreatedFormatter, defaultFormatter } from "pages/Admin/Users/UserComponents/UserList/Formatters";
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import { forColumnHeaderWrapper, getPrimaryButtonClass, printNameOrEmail } from "helpers/sf_utils";
import { customSortCaret } from "helpers/bootstrap_table_helper";
import { DEFAULT_TABLE_SORT_BY_CREATED_AT_IN_DESC, MODE, tosNameFormatter, TRUE_AND_FALSE } from "helpers/sf_constants";
import { getRefundPolicy, postRefundPolicy } from "store/refund-policy/actions";
import UpdateRefundPolicyModal from "./modal/UpdateRefundPolicyModal";

const RefundPolicy = () => {
  const dispatch = useDispatch();

  const { SearchBar } = Search

  const {
    refund_policy,
    refund_policy_loading,
  } = useSelector((state) => ({
    refund_policy: state.RefundPolicy.refund_policies,
    refund_policy_loading: state.RefundPolicy.loading,
  }));

  const [updateInsuranceCarrierModal, setUpdateInsuranceCarrierModal] = useState({ active: false, mode: null, row: null });

  /**
   * 
   * @param {boolean} action  // true for open modal, false for close modal
   * @param {string} mode  // create or update 
   * @param {object} row  // row data¸
   */
  const onClickhandleModalState = (active, mode = null, row = null) => {
    setUpdateInsuranceCarrierModal({ active, mode, row });
  }

  const onSubmitUpdatedState = (mode, data) => {
    dispatch(postRefundPolicy(data));
    onClickhandleModalState(TRUE_AND_FALSE.FALSE);
  }

  useEffect(() => {
    dispatch(getRefundPolicy());
  }, [dispatch]);

  const columns = [
    {
      dataField: "name",
      text: "Name",
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      formatter: (cellContent, row) => tosNameFormatter(cellContent, `${AppConfiguration.BACKEND_URL}/api/v1/refund_policy/${row.id}/download`),
      filter: textFilter({
        style: {
          display: 'none',
        }
      }),
    },
    {
      dataField: "description",
      text: "Description",
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      style: { maxWidth: '300px', textOverflow: 'ellipsis', overflow: 'hidden' },
      formatter: defaultFormatter,
    },
    {
      dataField: "updated_by",
      text: "Updated By",
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      formatter: (cell, row) => printNameOrEmail(row?.admin_user?.first_name, row?.admin_user?.last_name, row?.admin_user?.email, '--'),
    },
    {
      dataField: "created_at",
      text: "Created At",
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      formatter: dateCreatedFormatter
    }
  ]

  return (
    <React.Fragment>
      <div className="page-content" id="page-content-wrapper">
        <MetaTags>
          <title>Refund Policy | {AppConfiguration.WEBSITE}</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title="" backOption={false} breadcrumbItem="Refund Policy" />

          {/*Modal*/}
          <UpdateRefundPolicyModal
            show={updateInsuranceCarrierModal}
            onSubmitUpdatedState={onSubmitUpdatedState}
            onClickCloseModal={() => onClickhandleModalState(TRUE_AND_FALSE.FALSE)}
          />

          {/* Table starts */}
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <ToolkitProvider
                    keyField="id"
                    search
                    columns={columns}
                    data={refund_policy}
                    exportCSV={{
                      fileName: "RefundPolicy.csv",
                      exportAll: false,
                    }}
                  >
                    {(toolkitProps) => (
                      <>
                        <Form>
                          <Row className="">
                            <Col md="auto" className="">
                              <div className="mt-3 mb-0">
                                <div className="search-box d-inline-block mb-1">
                                  <div className="position-relative">
                                    <SearchBar
                                      className="rounded"
                                      {...toolkitProps.searchProps}
                                    />
                                    <i className="bx bx-search-alt search-icon" />
                                  </div>
                                </div>
                              </div>
                            </Col>
                            <Col xl="auto" className="ms-auto">
                              <Row>
                                <Col xl="auto">
                                  <FormGroup className="mb-0">
                                    <div>
                                      <a className={`btn ${getPrimaryButtonClass()}`}
                                        onClick={() => onClickhandleModalState(TRUE_AND_FALSE.TRUE, MODE.CREATE)}>
                                        <i className="bx bx-plus font-size-14 align-middle me-2" />
                                        New Refund Policy
                                      </a>
                                    </div>
                                  </FormGroup>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </Form>
                        <Row>
                          <Col xl="12">
                            <div
                              className="sfTable-Container"
                            >
                              {refund_policy_loading ? (
                                <SfLoadingSkeleton rows={8} cols={6} />
                              ) : (
                                <BootstrapTable
                                  keyField="id"
                                  columns={columns}
                                  data={refund_policy}
                                  responsive
                                  bordered={false}
                                  striped={false}
                                  defaultSorted={DEFAULT_TABLE_SORT_BY_CREATED_AT_IN_DESC}
                                  rowClasses="tr-hover"
                                  filter={filterFactory()}
                                  headerClasses="sftableHeader text-black thead-h50"
                                  classes="table align-middle table-nowrap text-black"
                                  headerWrapperClasses="thead-light"
                                  noDataIndication="You currently don't have any Refund Policies"
                                  sort={{ sortCaret: customSortCaret }}
                                  {...toolkitProps.baseProps}
                                />
                              )}
                            </div>
                          </Col>
                        </Row>
                      </>
                    )}
                  </ToolkitProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {/* Table ends */}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default RefundPolicy
